const $755957079a54393b$export$de7ead42144ee87f = document.querySelector(":root");
function $755957079a54393b$export$71511d61b312f219(id) {
    return document.getElementById(id);
}
function $755957079a54393b$export$3d8c2f653ac9d0b9(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}



function $39ccf5f87ba10929$var$makeEntityData({ scriptTag: scriptTag }) {
    let initialized = false;
    let ENTITIES = [];
    return Object.freeze({
        init: init,
        getAll: getAll,
        add: add,
        removeById: removeById
    });
    function init() {
        if (initialized) return;
        const serverData = JSON.parse(scriptTag.textContent);
        if (!Array.isArray(serverData)) return;
        serverData.forEach((entity)=>{
            ENTITIES.push({
                id: entity.id,
                title: entity.title
            });
        });
        initialized = true;
    }
    function getAll() {
        return ENTITIES;
    }
    function add(entity) {
        ENTITIES.push(entity);
    }
    function removeById(id) {
        const index = ENTITIES.findIndex((e)=>e.id === id);
        if (index === -1) return;
        ENTITIES.splice(index, 1);
    }
}
const $39ccf5f87ba10929$var$ENTITY_DATA = $39ccf5f87ba10929$var$makeEntityData({
    scriptTag: (0, $755957079a54393b$export$71511d61b312f219)("SERVER_DATA")
});
var $39ccf5f87ba10929$export$2e2bcd8739ae039 = $39ccf5f87ba10929$var$ENTITY_DATA;



function $9ba8302e2b54bc97$export$2e2bcd8739ae039({ addBtn: addBtn, events: events, action: action }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        initialized = true;
        _addListeners();
    }
    function _addListeners() {
        addBtn.addEventListener("click", (e)=>{
            events.emit(action);
        });
    }
}



function $e3e66118ecb9a43a$export$2e2bcd8739ae039({ header: header, logo: logo }) {
    const COLLAPSED_HEADER_HEIGHT = 50;
    const EXPANDED_HEADER_HEIGHT = 90;
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        initialized = true;
        _addScrollListener();
    }
    function _addScrollListener() {
        window.addEventListener("scroll", (e)=>{
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
            _handleHeaderOnScroll(scrollTop);
        });
    }
    function _handleHeaderOnScroll(scrollTop) {
        if (scrollTop > 0) _collapseHeader();
        else _expandHeader();
    }
    function _collapseHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", COLLAPSED_HEADER_HEIGHT + "px");
        header.classList.add("header-collapsed");
        logo.classList.add("logo-collapsed");
    }
    function _expandHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", EXPANDED_HEADER_HEIGHT + "px");
        header.classList.remove("header-collapsed");
        logo.classList.remove("logo-collapsed");
    }
}


function $a5ed5354c0712f77$export$2e2bcd8739ae039({ btn: btn, events: events, action: action }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        btn.classList.remove("no-display");
        _addListeners();
        initialized = true;
    }
    function _addListeners() {
        btn.addEventListener("click", (e)=>{
            events.emit(action);
        });
    }
}



class $f6e6a130867ac54c$export$2e2bcd8739ae039 {
    _overlay;
    _redirectUrl;
    _overlayBox;
    constructor(overlay, redirectUrl){
        this._overlay = overlay;
        this._redirectUrl = redirectUrl;
        this._addOnCloseListener();
        this._overlayBox = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-box")[0];
    }
    set(redirectUrl) {
        this._redirectUrl = redirectUrl;
    }
    render(content) {
        const wrapper = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-content")[0];
        wrapper.replaceChildren();
        wrapper.append(content);
        this.show();
    }
    show() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-scroll");
        this._overlay.classList.add("overlay-change");
        this._overlayBox.classList.add("overlay-box-change");
    }
    _addOnCloseListener() {
        this._overlay.addEventListener("click", (e)=>{
            this._onClose(e);
        });
    }
    _onClose(e) {
        const target = e.target;
        if (target === this._overlay) this.hide();
    }
    hide() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-scroll");
        this._overlayBox.classList.remove("overlay-box-change");
        setTimeout(()=>{
            this._overlay.classList.remove("overlay-change");
            if (this._redirectUrl) window.location.href = this._redirectUrl;
        }, 300);
    }
}


function $0916120d17a98724$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (!settingsBtn || !settingsOverlay) return;
        if (initialized) return;
        const SettingsOverlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(settingsOverlay);
        settingsBtn.addEventListener("click", ()=>{
            SettingsOverlay.show();
        });
        initialized = true;
    }
}





function $cae0d27c74eb6076$export$2e2bcd8739ae039({ overlayEl: overlayEl }) {
    const OVERLAY = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(overlayEl);
    const titleText = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(overlayEl, ".file-error-title")[0];
    const msgText = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(overlayEl, ".file-error-msg")[0];
    const okBtn = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(overlayEl, "button")[0];
    okBtn.addEventListener("click", ()=>OVERLAY.hide());
    return Object.freeze({
        show: show
    });
    function show(title, message) {
        titleText.innerText = title;
        msgText.innerHTML = message;
        OVERLAY.show();
    }
}


function $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr) {
    const el = document.createElement(tag);
    el.setAttribute("class", classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    return el;
}
function $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerText = text;
    return el;
}
function $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerHTML = html;
    return el;
}
function $9eeef69b55ee9859$export$ee31727d4121fca7(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("img", classes, attr);
}
function $9eeef69b55ee9859$export$f235d743d35a42d0(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("audio", classes, attr);
}
function $9eeef69b55ee9859$export$c34ace1158f06c39(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("video", classes, attr);
}
function $9eeef69b55ee9859$export$258b0eb2f6f9eed2(classes, attr) {
    return $9eeef69b55ee9859$export$ecd10de24f44b999("button", classes, attr.text, attr);
}
function $9eeef69b55ee9859$export$5a1947d71e311350(classes, attr) {
    const btn = $9eeef69b55ee9859$export$3d7cd8ed57263b30("button", classes, attr);
    const spinner = $9eeef69b55ee9859$export$3d7cd8ed57263b30("div", "spinner no-display");
    const span = $9eeef69b55ee9859$export$ecd10de24f44b999("span", "btn-span", attr.text);
    btn.append(spinner, span);
    return btn;
}
function $9eeef69b55ee9859$export$407ea597bae49e98(fragments) {
    const fragment = document.createDocumentFragment();
    fragments.forEach((fr)=>fragment.append(fr));
    return fragment;
}
function $9eeef69b55ee9859$export$aefe1a6be41e3d0c(tag, classes, target, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$e7e97c57fc2e401c(tag, classes, target, text, attr) {
    const el = $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$87eb1d92205d639(tag, classes, target, html, attr) {
    const el = $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr);
    target.append(el);
}



function $529b58f1c1c7b94b$export$2e2bcd8739ae039(action, data) {
    const ev = new CustomEvent("file-event-with-data", {
        detail: {
            action: action,
            data: data
        }
    });
    window.dispatchEvent(ev);
}


function $e852f8bec91ed2ea$export$2e2bcd8739ae039({ wrappers: wrappers }) {
    let initialized = false;
    const FILE_FORMS = [];
    let lastTarget = null;
    return Object.freeze({
        init: init,
        show: show,
        hide: hide,
        showFile: showFile,
        add: add,
        reset: reset,
        setURL: setURL,
        update: update,
        getURL: getURL,
        remove: remove
    });
    function _findByIndex(index) {
        return FILE_FORMS.find((form)=>form.id === index);
    }
    function init() {
        if (initialized) return;
        for(let i = 0; i < wrappers.length; i++){
            FILE_FORMS.push(_newForm(wrappers[i], i));
            _addListeners(FILE_FORMS[i]);
        }
        initialized = true;
    }
    // ---------- ADD NEW FORM
    function _newForm(wrapper, i) {
        return {
            id: i,
            wrapper: wrapper,
            formId: wrapper.getAttribute("data-id"),
            dropZone: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".dropzone")[0],
            placeHolder: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".file-placeholder")[0],
            fileInput: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, `input[type="file"]`)[0],
            cancelFileBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".remove-file-btn")[0],
            fileBox: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".file-reveal")[0],
            fileName: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".file-name")[0],
            sendBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".send-btn")[0],
            uploadFile: null,
            fileURL: wrapper.getAttribute("data-src")
        };
    }
    function add(id) {
        const wrappers = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".form");
        const newForm = _newForm(wrappers[wrappers.length - 1], id);
        newForm.fileURL = null;
        newForm.formId = null;
        _removeImg(newForm.wrapper);
        FILE_FORMS.push(newForm);
        reset(id);
        _addListeners(newForm);
    }
    function _addListeners(form) {
        form.fileInput.addEventListener("change", (e)=>{
            const target = e.currentTarget;
            _onFileInput(form, target.files);
        });
        form.dropZone.addEventListener("dragover", (e)=>e.preventDefault());
        form.dropZone.addEventListener("dragenter", (e)=>{
            lastTarget = e.target;
            _onDragEnter(form);
        });
        form.dropZone.addEventListener("dragleave", (e)=>{
            if (e.target === lastTarget) _onDragLeave(form);
        });
        form.dropZone.addEventListener("drop", (e)=>{
            e.preventDefault();
            _onDrop(form, e.dataTransfer?.files[0]);
        });
        form.cancelFileBtn.addEventListener("click", (e)=>reset(form.id));
        form.sendBtn.addEventListener("click", (e)=>_sendFile(form));
    }
    function reset(index) {
        const form = _findByIndex(index);
        if (!form) return;
        form.fileInput.value = ""; //FOR WHEN USER WANTS TO BROWSE AND SELECT SAME FILE THAT WAS PREVIOUSLY SELECTED
        form.uploadFile = null;
        form.sendBtn.disabled = true;
        form.fileBox.classList.add("no-display");
        form.fileName.innerText = "";
    }
    // ---------- SHOW VALID FILE INPUT
    function showFile(index, fileName) {
        const form = _findByIndex(index);
        if (!form) return;
        form.sendBtn.disabled = false;
        form.fileBox.classList.remove("no-display");
        form.fileName.innerText = fileName;
    }
    // ---------- SEND FILE
    function _sendFile(form) {
        if (!form.uploadFile) return;
        (0, $529b58f1c1c7b94b$export$2e2bcd8739ae039)("file-sent", {
            id: form.id,
            file: form.uploadFile
        });
    }
    // ---------- UPDATE FILE INPUT
    function setURL(index, url) {
        const form = _findByIndex(index);
        if (!form) return;
        form.fileURL = url;
    }
    function update(index, formEl, formId) {
        const form = _findByIndex(index);
        if (!form) return;
        form.formId = formId;
        _createImgFromUpload(form.dropZone, formEl, form.fileURL);
    }
    // ---------- CREATE & REMOVE IMAGE
    function _createImgFromUpload(dropZone, form, src) {
        if (!src) return;
        const imgWrapper = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".img-wrapper")[0];
        if (imgWrapper) {
            const img = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(imgWrapper, ".uploaded-img")[0];
            img.src = src;
            return;
        }
        const newImg = _createImg(src);
        dropZone.parentElement?.before(newImg);
    }
    function _createImg(src) {
        const wrapper = (0, $9eeef69b55ee9859$export$3d7cd8ed57263b30)("div", "width-100 img-wrapper");
        wrapper.append((0, $9eeef69b55ee9859$export$ee31727d4121fca7)("uploaded-img", {
            src: src,
            alt: ""
        }));
        return wrapper;
    }
    function _removeImg(form) {
        const imgEl = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".img-wrapper")[0];
        if (imgEl) imgEl.remove();
    }
    function getURL(index) {
        const form = _findByIndex(index);
        if (!form) return null;
        return form.fileURL;
    }
    // ---------- SHOW/HIDE FORM
    function show(index) {
        const form = _findByIndex(index);
        if (!form) return;
        form.dropZone.classList.remove("no-display");
    }
    function hide(index) {
        const form = _findByIndex(index);
        if (!form) return;
        form.dropZone.classList.add("no-display");
        reset(index);
    }
    // ---------- REMOVE
    function remove(id) {
        const formIndex = FILE_FORMS.findIndex((form)=>form.formId === id);
        if (formIndex === -1) return;
        FILE_FORMS.splice(formIndex, 1);
    }
    // ---------- ON FILE BROWSE / DRAG & DROP
    function _onFileInput(form, files) {
        if (!files) {
            reset(form.id);
            return;
        }
        const file = files[0];
        if (!file) {
            reset(form.id);
            return;
        } // when user hits cancel from native "browse file" window 
        form.uploadFile = file;
        (0, $529b58f1c1c7b94b$export$2e2bcd8739ae039)("file-inputted", {
            id: form.id,
            file: file
        });
    }
    function _onDragEnter(form) {
        form.dropZone.classList.add("dropzone-change");
        form.placeHolder.innerText = "Drop file...";
    }
    function _onDragLeave(form) {
        form.dropZone.classList.remove("dropzone-change");
        form.placeHolder.innerText = "Drag and drop file";
    }
    function _onDrop(form, file) {
        _onDragLeave(form);
        if (!file) {
            reset(form.id);
            return;
        }
        form.uploadFile = file;
        (0, $529b58f1c1c7b94b$export$2e2bcd8739ae039)("file-inputted", {
            id: form.id,
            file: file
        });
    }
}



function $a9392f0662cced48$export$2e2bcd8739ae039({ wrappers: wrappers }) {
    let initialized = false;
    const PROGRESS_COMPONENTS = [];
    return Object.freeze({
        init: init,
        showProgress: showProgress,
        update: update,
        add: add,
        reset: reset,
        remove: remove
    });
    function _findByIndex(index) {
        return PROGRESS_COMPONENTS.find((prog)=>prog.id === index);
    }
    function init() {
        if (initialized) return;
        for(let i = 0; i < wrappers.length; i++)PROGRESS_COMPONENTS.push(_newProgress(wrappers[i], i));
        initialized = true;
    }
    // ---------- ADD NEW PROGRESS
    function _newProgress(wrapper, i) {
        return {
            id: i,
            formId: wrapper.getAttribute("data-id"),
            wrapper: wrapper,
            fileName: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".progress-file-name")[0],
            progressBar: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".progress-bar")[0],
            percText: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(wrapper, ".progress-perc")[0]
        };
    }
    function add(id) {
        const wrappers = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".progress-wrapper");
        const newProgress = _newProgress(wrappers[wrappers.length - 1], id);
        newProgress.formId = null;
        newProgress.wrapper.removeAttribute("data-id");
        PROGRESS_COMPONENTS.push(newProgress);
        reset(id);
    }
    function reset(index) {
        const prog = _findByIndex(index);
        if (!prog) return;
        prog.wrapper.classList.add("no-display");
        prog.fileName.innerText = "";
        prog.percText.innerText = "";
        prog.progressBar.style.width = `0%`;
    }
    // ---------- SHOW/UPDATE PROGRESS
    function showProgress(index, fileName) {
        const prog = _findByIndex(index);
        if (!prog) return;
        prog.wrapper.classList.remove("no-display");
        prog.fileName.innerText = fileName;
    }
    function update(index, perc) {
        const prog = _findByIndex(index);
        if (!prog) return;
        prog.progressBar.style.width = `${perc}%`;
        prog.percText.innerText = `${perc}%`;
    }
    // ---------- REMOVE
    function remove(id) {
        const progIndex = PROGRESS_COMPONENTS.findIndex((prog)=>prog.formId === id);
        if (progIndex === -1) return;
        PROGRESS_COMPONENTS.splice(progIndex, 1);
    }
}




function $cd86d6b806a138de$export$2e2bcd8739ae039(action, data) {
    const ev = new CustomEvent("form-event-with-data", {
        detail: {
            action: action,
            data: data
        }
    });
    window.dispatchEvent(ev);
}



function $199f5777ad933961$export$2e2bcd8739ae039({ forms: forms, overlayEl: overlayEl, entity: entity, events: events, action: action }) {
    let initialized = false;
    let DELETE_PROMPT;
    const FORMS = [];
    return Object.freeze({
        init: init,
        update: update,
        add: add,
        remove: remove,
        validateForm: validateForm,
        getById: getById,
        submit: submit
    });
    function _findByIndex(index) {
        return FORMS.find((form)=>form.id === index);
    }
    function getById(index) {
        const form = _findByIndex(index);
        if (!form) return null;
        return {
            form: form.form,
            submitBtn: form.submitBtn
        };
    }
    function init() {
        if (initialized) return;
        DELETE_PROMPT = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(overlayEl);
        for(let i = 0; i < forms.length; i++){
            FORMS.push(_newForm(forms[i], i));
            _addListeners(FORMS[i]);
        }
        initialized = true;
    }
    // ---------- ADD NEW FORM
    function _newForm(formEl, i) {
        return {
            form: formEl,
            id: i,
            formId: formEl.getAttribute("data-id"),
            deleteBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formEl, ".delete-btn")[0],
            submitBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formEl, ".submit-btn")[0]
        };
    }
    function add() {
        const lastIndex = FORMS.length - 1;
        const origForm = FORMS[lastIndex].form;
        const newForm = origForm.cloneNode(true);
        const newFormObj = _newForm(newForm, FORMS[lastIndex].id + 1);
        _resetForm(newFormObj);
        _changeSubmitBtnText(newFormObj.submitBtn, `Add ${entity}`);
        _hideDeleteBtn(newFormObj.deleteBtn);
        _addListeners(newFormObj);
        FORMS.push(newFormObj);
        origForm.after(newForm);
        return newFormObj.id;
    }
    function _addListeners(formObj) {
        formObj.form.addEventListener("submit", (e)=>{
            e.preventDefault();
            _onFormSubmit(formObj);
        });
        formObj.deleteBtn.addEventListener("click", (e)=>_onDelete(formObj));
    }
    function _resetForm(formObj) {
        const { form: form } = formObj;
        formObj.formId = null;
        form.removeAttribute("data-id");
        form.removeAttribute("data-src");
        const inputs = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".input-fields");
        const checkBoxes = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, `input[type="checkbox"]`);
        checkBoxes.forEach((checkbox)=>checkbox.checked = false);
        const duplicables = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".duplicable");
        for(let i = 1; i < duplicables.length; i++)duplicables[i].remove();
        inputs.forEach((input)=>{
            input.value = "";
            input.removeAttribute("value");
            input.innerHTML = "";
        });
    }
    function _changeSubmitBtnText(submitBtn, text) {
        const buttonText = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, "span")[0];
        buttonText.innerText = text;
    }
    function _hideDeleteBtn(deleteBtn) {
        deleteBtn.classList.add("no-display");
    }
    // ---------- ON FORM SUBMIT
    function submit(index) {
        const form = _findByIndex(index);
        if (!form) return;
        _onFormSubmit(form);
    }
    function _onFormSubmit(formObj) {
        const { id: id, formId: formId, form: form, submitBtn: submitBtn } = formObj;
        if (!formId) {
            (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-created", {
                id: id,
                form: form,
                submitBtn: submitBtn
            });
            return;
        }
        (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-updated", {
            index: id,
            id: formId,
            form: form,
            submitBtn: submitBtn
        });
    }
    function update(index, formId) {
        const form = _findByIndex(index);
        if (!form) return;
        form.formId = formId;
        _changeSubmitBtnText(form.submitBtn, "Update");
        form.deleteBtn.classList.remove("no-display");
    }
    function validateForm(index) {
        const formObj = _findByIndex(index);
        if (!formObj) return;
        let isValid = true;
        const inputs = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formObj.form, ".input-fields");
        inputs.every((input)=>{
            if (!input.checkValidity()) {
                input.focus();
                isValid = false;
                return false;
            }
            return true;
        });
        return isValid;
    }
    // ---------- DELETE FORM HANDLING
    function remove(id) {
        const formIndex = FORMS.findIndex((form)=>form.formId === id);
        if (formIndex === -1) return;
        if (FORMS.length === 1) events.emit(action); //avoid having no forms to clone
        FORMS[formIndex].form.remove();
        FORMS.splice(formIndex, 1);
    }
    function _onDelete(formObj) {
        if (!formObj.formId) return;
        _renderDeletePrompt(formObj.formId);
    }
    function _renderDeletePrompt(id) {
        const confirmBtn = (0, $9eeef69b55ee9859$export$5a1947d71e311350)("btns submit-btn", {
            type: "button",
            text: "Yes",
            title: "Yes"
        });
        const cancelBtn = (0, $9eeef69b55ee9859$export$258b0eb2f6f9eed2)("btns submit-btn error-btn", {
            type: "button",
            text: "No",
            title: "No"
        });
        const form = (0, $9eeef69b55ee9859$export$3d7cd8ed57263b30)("form", "flex-container flex-center prompt-btns");
        form.append(confirmBtn, cancelBtn);
        const fragments = [
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", "text-center", `Delete ${entity}`),
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("p", "text-center", `Are you sure you want to delete this ${entity.toLowerCase()}?`),
            form
        ];
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        DELETE_PROMPT.render(fragment);
        confirmBtn.addEventListener("click", (e)=>{
            (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-deleted", {
                id: id,
                form: form,
                submitBtn: confirmBtn
            });
        });
        cancelBtn.addEventListener("click", (e)=>DELETE_PROMPT.hide());
    }
}






function $489b47e8f4dbdef0$export$2e2bcd8739ae039({ overlayEl: overlayEl, entity: entity }) {
    let initialized = false;
    let PROMPT;
    return Object.freeze({
        init: init,
        showModal: showModal
    });
    function init() {
        if (initialized) return;
        PROMPT = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(overlayEl);
        initialized = true;
    }
    function showModal(items) {
        const fragments = [];
        fragments.push((0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", "text-center no-margin", `Reorder ${entity}s`), (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("p", "text-center no-margin", `Drag and drop the ${entity.toLowerCase()}s below to reorder.`));
        const wrapper = (0, $9eeef69b55ee9859$export$3d7cd8ed57263b30)("div", "reorder-wrapper flex-container flex-col flex-center");
        items.forEach((item)=>{
            const itemEl = (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("div", "reorder-item text-center draggable", item.title, {
                draggable: "true",
                "data-id": item.id
            });
            wrapper.append(itemEl);
        });
        fragments.push(wrapper, (0, $9eeef69b55ee9859$export$5a1947d71e311350)("btns submit-btn", {
            id: "submitReorderBtn",
            type: "button",
            text: "Update Order",
            title: "Update Order"
        }));
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        PROMPT.render(fragment);
        _addListeners();
    }
    function _addListeners() {
        const dragContainer = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(overlayEl, ".reorder-wrapper")[0];
        const draggables = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(dragContainer, ".reorder-item");
        draggables.forEach((draggable)=>{
            draggable.addEventListener("dragstart", _onDragStart);
            draggable.addEventListener("dragend", _onDragEnd);
        });
        dragContainer.addEventListener("dragover", _onDragOver);
        (0, $755957079a54393b$export$71511d61b312f219)("submitReorderBtn")?.addEventListener("click", _onSubmitOrder);
    }
    function _onDragStart() {
        this.classList.add("dragging");
    }
    function _onDragEnd() {
        this.classList.remove("dragging");
    }
    function _onDragOver(e) {
        e.preventDefault();
        const dragContainer = e.currentTarget;
        const afterElement = _getDragAfterElement(dragContainer, e.clientY).element;
        const draggable = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(dragContainer, ".dragging")[0];
        if (afterElement == null) dragContainer.appendChild(draggable);
        else dragContainer.insertBefore(draggable, afterElement);
    }
    function _getDragAfterElement(container, y) {
        const draggableElements = [
            ...(0, $755957079a54393b$export$3d8c2f653ac9d0b9)(container, ".draggable:not(.dragging)")
        ];
        const result = draggableElements.reduce((closest, child)=>{
            const box = child.getBoundingClientRect();
            const offset = y - box.top - box.height / 2;
            if (offset < 0 && offset > closest.offset) return {
                offset: offset,
                element: child
            };
            else return closest;
        }, {
            offset: Number.NEGATIVE_INFINITY
        });
        return result;
    }
    function _onSubmitOrder() {
        const dragContainer = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(overlayEl, ".reorder-wrapper")[0];
        const draggables = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(dragContainer, ".reorder-item");
        const events = [];
        draggables.forEach((item, i)=>{
            events.push({
                id: item.getAttribute("data-id"),
                orderIndex: i
            });
        });
        (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("entities-reordered", {
            submitBtn: this,
            entities: events
        });
    }
}


function $58f9f437543be56c$export$2e2bcd8739ae039(actions) {
    let events = [];
    actions.forEach((action)=>{
        events.push({
            event: new CustomEvent("app-event", {
                detail: {
                    action: action
                }
            }),
            action: action
        });
    });
    return Object.freeze({
        emit: emit
    });
    function emit(action) {
        const ev = events.find((event)=>event.action === action);
        window.dispatchEvent(ev.event);
    }
}


const $595b5c985818707c$var$actions = [
    "add-event-clicked",
    "reorder-btn-clicked"
];
const $595b5c985818707c$var$ACTIONS = [
    ...$595b5c985818707c$var$actions
];
const $595b5c985818707c$var$APP_EVENTS = (0, $58f9f437543be56c$export$2e2bcd8739ae039)($595b5c985818707c$var$ACTIONS);
var $595b5c985818707c$export$2e2bcd8739ae039 = $595b5c985818707c$var$APP_EVENTS;


const $57bb5d06d3acd1e8$var$forms = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".form");
const $57bb5d06d3acd1e8$var$eventForms = (0, $199f5777ad933961$export$2e2bcd8739ae039)({
    forms: $57bb5d06d3acd1e8$var$forms,
    overlayEl: (0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"),
    entity: "Event",
    events: (0, $595b5c985818707c$export$2e2bcd8739ae039),
    action: "add-event-clicked"
});
const $57bb5d06d3acd1e8$var$fileForms = (0, $e852f8bec91ed2ea$export$2e2bcd8739ae039)({
    wrappers: $57bb5d06d3acd1e8$var$forms
});
const $57bb5d06d3acd1e8$var$fileError = (0, $cae0d27c74eb6076$export$2e2bcd8739ae039)({
    overlayEl: (0, $755957079a54393b$export$71511d61b312f219)("fileErrorOverlay")
});
const $57bb5d06d3acd1e8$var$progressComponents = (0, $a9392f0662cced48$export$2e2bcd8739ae039)({
    wrappers: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".progress-wrapper")
});
const $57bb5d06d3acd1e8$var$reOrderModal = (0, $489b47e8f4dbdef0$export$2e2bcd8739ae039)({
    overlayEl: (0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"),
    entity: "Event"
});
const $57bb5d06d3acd1e8$var$APP_COMPONENTS = Object.freeze({
    eventForms: $57bb5d06d3acd1e8$var$eventForms,
    fileForms: $57bb5d06d3acd1e8$var$fileForms,
    fileError: $57bb5d06d3acd1e8$var$fileError,
    progressComponents: $57bb5d06d3acd1e8$var$progressComponents,
    reOrderModal: $57bb5d06d3acd1e8$var$reOrderModal
});
var $57bb5d06d3acd1e8$export$2e2bcd8739ae039 = $57bb5d06d3acd1e8$var$APP_COMPONENTS;



var $d3c4c674b2322be6$export$2e2bcd8739ae039 = {
    execute: async ()=>{
        const newIndex = (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.add();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.add(newIndex);
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.add(newIndex);
    }
};




function $9c5c4c45b9fa185f$export$2e2bcd8739ae039({ btn: btn }) {
    const submitBtn = btn;
    const spinner = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".spinner")[0];
    const buttonSpan = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".btn-span")[0];
    return Object.freeze({
        reset: reset,
        onLoading: onLoading
    });
    function reset() {
        _btnLoader(false);
    }
    function onLoading() {
        _btnLoader(true);
    }
    function _btnLoader(isLoading) {
        if (isLoading) {
            submitBtn.disabled = true;
            spinner.classList.remove("no-display");
            buttonSpan.classList.add("no-display");
        } else {
            submitBtn.disabled = false;
            spinner.classList.add("no-display");
            buttonSpan.classList.remove("no-display");
        }
    }
}



function $01df58dec21e7277$export$2e2bcd8739ae039({ form: form, submitBtn: submitBtn }) {
    _preventSubmit();
    const LOADER = (0, $9c5c4c45b9fa185f$export$2e2bcd8739ae039)({
        btn: submitBtn
    });
    LOADER.onLoading();
    return Object.freeze({
        afterResponse: afterResponse
    });
    function afterResponse(resetForm) {
        _enableSubmit();
        LOADER.reset();
        if (resetForm) form?.reset();
    }
    function _preventSubmit() {
        document.addEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-pointers");
    }
    function _enableSubmit() {
        document.removeEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-pointers");
    }
    function _onPreventFormSubmit(e) {
        if (e.code === "Enter") e.preventDefault(); //avoid submitting form
    }
}





function $e3d294463b74ae93$export$e4dd48968eea87b5() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 50 50");
    svg.setAttribute("width", "30");
    svg.setAttribute("height", "30");
    svg.setAttribute("transform", "scale(0.7)");
    svg.innerHTML = `
        <path fill="#00bf6f"
            d="m25,0.572441c-13.489683,0 -24.427559,10.937876 -24.427559,24.427559c0,13.489683 10.937876,24.427559 24.427559,24.427559c13.489683,0 24.427559,-10.937876 24.427559,-24.427559c0,-13.489683 -10.937876,-24.427559 -24.427559,-24.427559zm12.530029,16.259594l-15.169078,19.465711c-0.119957,0.119957 -0.31625,0.381681 -0.556163,0.381681c-0.250819,0 -0.414396,-0.174483 -0.556163,-0.31625c-0.141767,-0.141767 -8.604171,-8.277017 -8.604171,-8.277017l-0.163577,-0.163577c-0.065431,-0.098146 -0.119957,-0.218103 -0.119957,-0.348965c0,-0.130862 0.054526,-0.250819 0.119957,-0.348965c0.043621,-0.043621 0.076336,-0.076336 0.119957,-0.130862c0.839697,-0.883318 2.540902,-2.671764 2.649954,-2.780816c0.141767,-0.141767 0.261724,-0.327155 0.523448,-0.327155c0.272629,0 0.447112,0.229008 0.577973,0.35987c0.130862,0.130862 4.907322,4.721934 4.907322,4.721934l12.137443,-15.594379c0.109052,-0.087241 0.239914,-0.152672 0.381681,-0.152672c0.141767,0 0.272629,0.054526 0.381681,0.141767l3.336979,2.628144c0.087241,0.109052 0.141767,0.239914 0.141767,0.381681c0.010905,0.141767 -0.043621,0.261724 -0.109052,0.35987z" />`;
    return svg;
}
function $e3d294463b74ae93$export$2b895fe12934f65() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 64 64");
    svg.setAttribute("width", "50");
    svg.setAttribute("height", "50");
    svg.innerHTML = `
        <path fill="#ff618a" d="M30.16,11.51,6.84,51.9a2.13,2.13,0,0,0,1.84,3.19H55.32a2.13,2.13,0,0,0,1.84-3.19L33.84,11.51A2.13,2.13,0,0,0,30.16,11.51Z"/>
        <path fill="#1e1f29" d="M29,46a3,3,0,1,1,3,3A2.88,2.88,0,0,1,29,46Zm1.09-4.66-.76-15h5.26l-.73,15Z"/>`;
    return svg;
}


function $bac9fd8885449360$var$makeResponse() {
    const overlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)((0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"));
    return Object.freeze({
        show: show
    });
    function show({ ...args }) {
        const classes = args.resp.success ? "text-center" : "error text-center";
        const svg = args.resp.success ? (0, $e3d294463b74ae93$export$e4dd48968eea87b5)() : (0, $e3d294463b74ae93$export$2b895fe12934f65)();
        const textHTML = args.resp.success || args.resp.error ? args.respText : "A server-side error occured";
        const btnClasses = args.resp.success ? "submit-btn success-btn no-margin btns" : "submit-btn error-btn no-margin btns";
        const okBtn = (0, $9eeef69b55ee9859$export$258b0eb2f6f9eed2)(btnClasses, {
            type: "button",
            title: "OK",
            text: "OK"
        });
        const fragments = [
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", classes, args.respTitle),
            svg,
            (0, $9eeef69b55ee9859$export$69b2a7fcb8b634f)("p", classes, textHTML),
            okBtn
        ];
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        overlay.render(fragment);
        if (args.onRedirect) overlay.set(args.onRedirect);
        okBtn.addEventListener("click", ()=>{
            overlay.hide();
        });
    }
}
const $bac9fd8885449360$var$ServerResponse = $bac9fd8885449360$var$makeResponse();
var $bac9fd8885449360$export$2e2bcd8739ae039 = $bac9fd8885449360$var$ServerResponse;


function $6f42e8eea5ca176e$var$makeRequest() {
    return Object.freeze({
        post: post
    });
    async function post(url, payload) {
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        };
        try {
            const response = await fetch(url, options);
            return await response.json();
        } catch (err) {
            console.error(err);
            return {
                success: false,
                error: "An unexpected error occured<br><br>Please check your internet connection"
            };
        }
    }
}
const $6f42e8eea5ca176e$var$Request = $6f42e8eea5ca176e$var$makeRequest();
var $6f42e8eea5ca176e$export$2e2bcd8739ae039 = $6f42e8eea5ca176e$var$Request;



var $9b31fea5cf6d0e96$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { id: id, form: form, submitBtn: submitBtn } = data;
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/events/delete", {
            id: id
        });
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Event deleted successfully.`
            });
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.remove(id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.remove(id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.remove(id);
            (0, $39ccf5f87ba10929$export$2e2bcd8739ae039).removeById(id);
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};







var $fa633ae0ba615604$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { id: id, form: form, submitBtn: submitBtn } = data;
        const fileURL = (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.getURL(id);
        if (!fileURL) {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("INCOMPLETE", "Please upload an image before submitting.");
            return;
        }
        const payload = {
            type: form.eventtype.value.trim(),
            desc: form.description.value.trim(),
            image: fileURL,
            video: form.videolink.value.trim() || null,
            orderIndex: (0, $39ccf5f87ba10929$export$2e2bcd8739ae039).getAll().length,
            ensemble: {
                2: {
                    price: Number(form.two.value.trim()),
                    video: form.videotwo.value.trim() || null
                },
                3: {
                    price: Number(form.three.value.trim()),
                    video: form.videothree.value.trim() || null
                },
                4: {
                    price: Number(form.four.value.trim()),
                    video: form.videofour.value.trim() || null
                },
                5: {
                    price: Number(form.five.value.trim()),
                    video: form.videofive.value.trim() || null
                },
                6: {
                    price: Number(form.six.value.trim()),
                    video: form.videosix.value.trim() || null
                },
                7: {
                    price: Number(form.seven.value.trim()),
                    video: form.videoseven.value.trim() || null
                }
            }
        };
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/events/create", payload);
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Event added successfully.`
            });
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.update(id, response.id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.update(id, form, response.id);
            (0, $39ccf5f87ba10929$export$2e2bcd8739ae039).add({
                id: response.id,
                title: response.title
            });
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};






var $1be7963ba6ee2375$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { index: index, id: id, form: form, submitBtn: submitBtn } = data;
        const fileURL = (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.getURL(index);
        if (!fileURL) {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("INCOMPLETE", "Please upload an image before submitting.");
            return;
        }
        const payload = {
            id: id,
            type: form.eventtype.value.trim(),
            desc: form.description.value.trim(),
            image: fileURL,
            video: form.videolink.value.trim() || null,
            orderIndex: index,
            ensemble: {
                2: {
                    price: Number(form.two.value.trim()),
                    video: form.videotwo.value.trim() || null
                },
                3: {
                    price: Number(form.three.value.trim()),
                    video: form.videothree.value.trim() || null
                },
                4: {
                    price: Number(form.four.value.trim()),
                    video: form.videofour.value.trim() || null
                },
                5: {
                    price: Number(form.five.value.trim()),
                    video: form.videofive.value.trim() || null
                },
                6: {
                    price: Number(form.six.value.trim()),
                    video: form.videosix.value.trim() || null
                },
                7: {
                    price: Number(form.seven.value.trim()),
                    video: form.videoseven.value.trim() || null
                }
            }
        };
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/events/update", payload);
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Event updated successfully.`
            });
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.update(index, form, id);
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};



function $50265e3754e3b39e$var$makeFileInputted() {
    return Object.freeze({
        execute: execute
    });
    async function execute(data) {
        const MAX_SIZE = 307200; // 300kb size limit
        if (!data.file.type || data.file.type !== "image/jpeg") {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.reset(data.id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("INVALID FILE", "Invalid file type. <br>Please choose a jpeg file.");
            return;
        }
        if (data.file.size > MAX_SIZE) {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.reset(data.id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("FILE SIZE TOO BIG", "Please choose a file with a size no bigger than 300KB.");
            return;
        }
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.showFile(data.id, data.file.name);
    }
}
const $50265e3754e3b39e$var$fileInputted = $50265e3754e3b39e$var$makeFileInputted();
var $50265e3754e3b39e$export$2e2bcd8739ae039 = $50265e3754e3b39e$var$fileInputted;



function $55a9f71e482f2114$export$2e2bcd8739ae039({ file: file, path: path, id: id }) {
    const BUNNY_KEY = "5846b93d-fd17-4358-8a47a6b55a34-8211-4af1";
    const DEST_PATH = "https://ny.storage.bunnycdn.com/tbn-storage/";
    const CDN_STPRAGE = "https://thebrooklynnomads.b-cdn.net/";
    return Object.freeze({
        upload: upload
    });
    async function upload() {
        return await new Promise((resolve, reject)=>{
            const req = new XMLHttpRequest();
            req.open("PUT", `${DEST_PATH}${path}`, true);
            req.setRequestHeader("Content-Type", "application/octet-stream");
            req.setRequestHeader("AccessKey", BUNNY_KEY);
            req.upload.onprogress = (e)=>{
                const size = file.size;
                if (e.loaded <= size) {
                    const perc = Math.round(e.loaded / size * 100);
                    (0, $529b58f1c1c7b94b$export$2e2bcd8739ae039)("progress-received", {
                        id: id,
                        perc: perc
                    });
                }
            };
            req.onload = (e)=>{
                if (req.status === 0 || req.status >= 200 && req.status < 400) return resolve(`${CDN_STPRAGE}${path}`);
                else return reject(new Error(req.responseText));
            };
            req.onerror = (error)=>{
                console.error(error);
                return reject(new Error(error));
            };
            req.send(file);
        });
    }
}




function $7a95750b07f0aee0$var$makeFileSent() {
    return Object.freeze({
        execute: execute
    });
    async function execute(data) {
        const { id: id, file: file } = data;
        const isFormValid = (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.validateForm(id);
        if (!isFormValid) {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("INCOMPLETE", "Incomplete event form. <br>Please fill out all the required fields first before uploading.");
            return;
        }
        const eventForm = (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.getById(id);
        if (!eventForm) return;
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: eventForm.form,
            submitBtn: eventForm.submitBtn
        });
        try {
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.showProgress(id, file.name);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.hide(id);
            const uploader = (0, $55a9f71e482f2114$export$2e2bcd8739ae039)({
                file: file,
                path: `event-types/${file.name}`,
                id: id
            });
            const fileURL = await uploader.upload();
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.setURL(id, fileURL);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.reset(id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.show(id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.submit(id);
        } catch (e) {
            console.error("CAUGHT UPLOAD ERROR");
            console.error(e);
            formRequest.afterResponse(false);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileError.show("ERROR", "An error occurred while uploading the file. <br><br>Please check your internet connection");
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.show(id);
            (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.reset(id);
        }
    }
}
const $7a95750b07f0aee0$var$fileSent = $7a95750b07f0aee0$var$makeFileSent();
var $7a95750b07f0aee0$export$2e2bcd8739ae039 = $7a95750b07f0aee0$var$fileSent;



var $cf79d5e7cda9d6df$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.update(data.id, data.perc);
    }
};




var $004849d93a58cef3$export$2e2bcd8739ae039 = {
    execute: async ()=>{
        const mockData = (0, $39ccf5f87ba10929$export$2e2bcd8739ae039).getAll();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).reOrderModal.showModal(mockData);
    }
};





var $a5dd4c2fc8f0e788$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { submitBtn: submitBtn, entities: entities } = data;
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/events/reorder", entities);
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Events reordered successfully.`,
                onRedirect: "/events"
            });
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};


function $1e438f0975d7786b$var$makeEventRouter() {
    const router = {
        "add-event-clicked": (0, $d3c4c674b2322be6$export$2e2bcd8739ae039),
        "reorder-btn-clicked": (0, $004849d93a58cef3$export$2e2bcd8739ae039)
    };
    const routerWithData = {};
    const formRouterWithData = {
        "form-created": (0, $fa633ae0ba615604$export$2e2bcd8739ae039),
        "form-updated": (0, $1be7963ba6ee2375$export$2e2bcd8739ae039),
        "form-deleted": (0, $9b31fea5cf6d0e96$export$2e2bcd8739ae039),
        "entities-reordered": (0, $a5dd4c2fc8f0e788$export$2e2bcd8739ae039)
    };
    const fileRouterWithData = {
        "file-inputted": (0, $50265e3754e3b39e$export$2e2bcd8739ae039),
        "file-sent": (0, $7a95750b07f0aee0$export$2e2bcd8739ae039),
        "progress-received": (0, $cf79d5e7cda9d6df$export$2e2bcd8739ae039)
    };
    return Object.freeze({
        get: get,
        getWithData: getWithData,
        getFormActionWithData: getFormActionWithData,
        getFileActionWithData: getFileActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
    function getFileActionWithData(action) {
        return fileRouterWithData[action];
    }
}
const $1e438f0975d7786b$var$APP_VIEWS = $1e438f0975d7786b$var$makeEventRouter();
var $1e438f0975d7786b$export$2e2bcd8739ae039 = $1e438f0975d7786b$var$APP_VIEWS;



function $ada783ca194cb361$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay, header: header, logo: logo, addBtn: addBtn, reOrderBtn: reOrderBtn }) {
    _initAppShell();
    return Object.freeze({
        resize: resize,
        executeEvent: executeEvent,
        executeEventWithData: executeEventWithData,
        executeFormEventWithData: executeFormEventWithData,
        executeFileEventWithData: executeFileEventWithData
    });
    function _initAppShell() {
        (0, $39ccf5f87ba10929$export$2e2bcd8739ae039).init();
        (0, $0916120d17a98724$export$2e2bcd8739ae039)({
            settingsBtn: settingsBtn,
            settingsOverlay: settingsOverlay
        }).init();
        (0, $e3e66118ecb9a43a$export$2e2bcd8739ae039)({
            header: header,
            logo: logo
        }).init();
        (0, $9ba8302e2b54bc97$export$2e2bcd8739ae039)({
            addBtn: addBtn,
            events: (0, $595b5c985818707c$export$2e2bcd8739ae039),
            action: "add-event-clicked"
        }).init();
        (0, $a5ed5354c0712f77$export$2e2bcd8739ae039)({
            btn: reOrderBtn,
            events: (0, $595b5c985818707c$export$2e2bcd8739ae039),
            action: "reorder-btn-clicked"
        }).init();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).reOrderModal.init();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).eventForms.init();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).fileForms.init();
        (0, $57bb5d06d3acd1e8$export$2e2bcd8739ae039).progressComponents.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = (0, $1e438f0975d7786b$export$2e2bcd8739ae039).get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = (0, $1e438f0975d7786b$export$2e2bcd8739ae039).getWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFormEventWithData(detail) {
        const view = (0, $1e438f0975d7786b$export$2e2bcd8739ae039).getFormActionWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFileEventWithData(detail) {
        const view = (0, $1e438f0975d7786b$export$2e2bcd8739ae039).getFileActionWithData(detail.action);
        await view.execute(detail.data);
    }
}


(async function() {
    const overlays = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".overlay");
    overlays.forEach((overlay)=>overlay.classList.remove("no-display"));
    const app = (0, $ada783ca194cb361$export$2e2bcd8739ae039)({
        settingsBtn: (0, $755957079a54393b$export$71511d61b312f219)("settingsBtn"),
        settingsOverlay: (0, $755957079a54393b$export$71511d61b312f219)("settingsOverlay"),
        header: (0, $755957079a54393b$export$71511d61b312f219)("header"),
        logo: (0, $755957079a54393b$export$71511d61b312f219)("logo"),
        addBtn: (0, $755957079a54393b$export$71511d61b312f219)("addBtn"),
        reOrderBtn: (0, $755957079a54393b$export$71511d61b312f219)("reOrderBtn")
    });
    app.resize();
    window.addEventListener("app-event", (e)=>{
        app.executeEvent(e.detail.action);
    });
    window.addEventListener("app-event-with-data", (e)=>{
        app.executeEventWithData(e.detail);
    });
    window.addEventListener("form-event-with-data", (e)=>{
        app.executeFormEventWithData(e.detail);
    });
    window.addEventListener("file-event-with-data", (e)=>{
        app.executeFileEventWithData(e.detail);
    });
    window.addEventListener("resize", app.resize);
    document.documentElement.addEventListener("touchstart", function(e) {}); //hover behaviour on touch devices
})();


//# sourceMappingURL=events.34559e46.js.map
